/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateImageBase64Dto } from '../../models/create-image-base-64-dto';
import { ImageUploadResult } from '../../models/image-upload-result';

export interface ImagesControllerUploadFileBase64$Params {
      body: CreateImageBase64Dto
}

export function imagesControllerUploadFileBase64(http: HttpClient, rootUrl: string, params: ImagesControllerUploadFileBase64$Params, context?: HttpContext): Observable<StrictHttpResponse<ImageUploadResult>> {
  const rb = new RequestBuilder(rootUrl, imagesControllerUploadFileBase64.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ImageUploadResult>;
    })
  );
}

imagesControllerUploadFileBase64.PATH = '/images/uploadImageBase64';
